import React from "react";

import { Helmet } from "react-helmet";

import Header from "../components/header";
import PrimaryPinkButton from "../components/primary-pink-button";
import OutlineGrayButton from "../components/outline-gray-button";
import OutlineBlackButton from "../components/outline-black-button";
import ListItem from "../components/list-item";
import Footer from "../components/footer";
import Dropzone from "../components/Dropzone/Dropzone";
import Images from "../components/Images/Images";
import "./home.css";

const Home = (props) => {
  return (
    <div>
      <div className="home-container">
        <Helmet>
          <title>Mabinogi Visual Chat Converter</title>
          <meta property="og:title" content="Mabinogi Visual Chat Converter" />
        </Helmet>
        <Header></Header>
        <div className="home-hero">
          <div className="home-container01">
            <div className="home-card">
              <Dropzone></Dropzone>
            </div>
          </div>
        </div>
        <img
          alt="image"
          src="/images/3LH9DuB.jpg"
          loading="Mabiongi"
          className="home-image4"
        />
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Home;
